"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleNames = exports.Title = exports.TerminalInfo = exports.StreetViewLink = exports.Photo = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius  : ", "px;\n  display        : flex;\n  flex-direction : column;\n  justify-content: center;\n  padding        : ", "px 0;\n  width          : ", ";\n"])), _widths.widths.base, _widths.widths.base * 3, function (props) {
  return props.width ? typeof props.width === 'string' ? "".concat(props.width) : "".concat(props.width, "px") : "".concat(_widths.widths.base * 40, "px");
});

exports.Container = Container;
Container.displayName = 'Container';

var Photo = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: ", "px;\n  width     : 100%;\n\n  & img {\n    width   : 100%;\n  }\n"])), _widths.widths.base);

exports.Photo = Photo;
Photo.displayName = 'Photo';

var StreetViewLink = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size  : 14px;\n  font-weight: ", ";\n  line-height: 1.43;\n  margin-top : ", "px;\n  text-align : left;\n"])), _widths.font.semi, _widths.widths.base);

exports.StreetViewLink = StreetViewLink;
StreetViewLink.displayName = 'StreetViewLink';

var TerminalInfo = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 12px;\n  font-weight: ", ";\n  line-height: 1.67;\n  margin-top : ", "px;\n  text-align : left;\n"])), _palette.palette.grey, _widths.font.regular, _widths.widths.base);

exports.TerminalInfo = TerminalInfo;
TerminalInfo.displayName = 'TerminalInfo';

var Title = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 12px;\n  font-weight: ", ";\n  line-height: 1.67;\n  text-align : left;\n"])), _palette.palette.bobBlack, _widths.font.regular);

exports.Title = Title;
Title.displayName = 'Title';

var TitleNames = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 14px;\n  font-weight: ", ";\n  line-height: 1.43;\n  text-align : left;\n"])), _palette.palette.bobBlack, _widths.font.semi);

exports.TitleNames = TitleNames;
TitleNames.displayName = 'TitleNames';